// extracted by mini-css-extract-plugin
module.exports = {"first-block":"styles_first-block__Olpof","content":"styles_content__ezOd1","header":"styles_header__YiyX2","subheader":"styles_subheader__mxNDG"};